module.exports = __webpack_public_path__ + "img/honer17.be335c09.jpg";